<template>
	<view>
		<!-- 图标类型扫描 -->
		<view @tap="init" :style="{'width':width+'rpx','height':height+'rpx'}" v-if="type=='icon'">
			<image :src="scanImg" mode="" style="width: 100%;height: 100%;border: 1px dashed rgb(154, 154, 154);" v-if="isShowScanImg"></image>
			<text v-if="scanText!=''">{{scanText}}</text>
		</view>
		<!-- 按钮类型扫描 -->
		<u-button :type="buttonType" @tap="init" :style="{'width':width+'rpx','height':height+'rpx'}" v-if="type=='button'">
			<image :src="scanImg" mode="" style="width: 100%;height: 100%;border: 1px dashed rgb(154, 154, 154);" v-if="isShowScanImg"></image>
			<text v-if="scanText!=''" :style="{'font-size':fontSize}">{{scanText}}</text>
		</u-button>
		<view @tap="init" v-if="type=='iconByProps'">
			<slot name="icon"></slot>
		</view>
	</view>
</template>

<script>
	export default {
		props: {
			//是否固定导航栏
			scanImg: {
				type: String,
				default: '/static/scan.png'
			},
			// 是否显示图标
			isShowScanImg: {
				type: Boolean,
				default: true
			},
			// 按钮文字
			scanText: {
				type: String,
				default: ''
			},
			//图标宽度，单位rpx
			width: {
				type: String | Number,
				default: '50'
			},
			//图标高度，单位rpx
			height: {
				type: String | Number,
				default: '50'
			},
			//按钮展示方式是：图标（icon）或是按钮 （button）
			type: {
				type: String,
				default: 'icon'
			},
			//按钮类型下button的类型primary、default等
			buttonType: {
				type: String,
				default: 'primary'
			},
			fontSize: {
				type: String,
				default: '28rpx'
			}
		},
		data() {
			return {
				content: null,
				scanBarVew: null,
				scanBackVew: null,
				scanBarText: null,
				barcode: null,
				flash: false,
				tip: '将二维码放入框中，即可自动扫描',
			}
		},
		onShow() {
			// 页面展示时，重新启动扫描检测
			if (this.barcode) {
				this.barcode.start()
			}
		},
		mounted() {
			// this.init()
		},
		methods: {
			init() {
				// #ifdef MP-WEIXIN
				// 微信小程序环境
				uni.scanCode({
					success: (res) => {
						this.$emit('scanCode', res.result)
						// console.log('条码类型：' + res.scanType);
						// console.log('条码内容：' + res.result);
					}
				});
				// #endif
				// #ifdef H5
				/*微信H5扫码和钉钉H5*/
				this.$wechat.scanQRCode(res => {
					this.$emit('scanCode', res)
				});
				// #endif

				// if (this.$wechat.isWechat()=='isWechat' || this.$wechat.isWechat()=='isDingTalk') {
				// 	/*微信端H5扫码*/
				// 	this.$wechat.scanQRCode(res => {
				// 		this.$emit('scanCode', res)
				// 	});
				// }else {
				// 	// App端H5扫码，调用uniwebView扫码
				// 	this.createBarcode()
				// 	setTimeout(()=>{
				// 		this.createTipInfoView()
				// 		this.createFlashBarView()
				// 		// this.createBackBtn()
				// 		this.createBackText()
				// 	},500)

				// }

			},
			/**
			 * 创建二维码
			 * @param {Object} currentWebview
			 */
			createBarcode(currentWebview) {
				if (!this.barcode) {
					this.barcode = plus.barcode.create('barcode', [plus.barcode.QR], {
						top: `0px`,
						left: '0px',
						height: `100%`,
						width: '100%',
						position: 'absolute',
						background: '#1890ff',
						frameColor: '#1890ff',
						scanbarColor: '#1890ff',
					});
					this.barcode.onmarked = this.onmarked;
					this.barcode.setFlash(this.flash);
					//此处未演示扫码成功回调的地址设置，实际请参考HTML5Plus API自行处理  
					//注意扫码区域需为正方形，否则影响扫码识别率  
					plus.webview.currentWebview().append(this.barcode);
				}
				this.barcode.start()
			},

			/**
			 * 创建提示信息
			 * @param {Object} currentWebview
			 */
			createTipInfoView(currentWebview) {
				this.content = new plus.nativeObj.View('content', {
						top: '0px',
						left: '0px',
						height: '100%',
						width: '100%'
					},
					[{
						tag: 'font',
						id: 'scanTips',
						text: this.tip,
						textStyles: {
							size: '14px',
							color: '#ffffff',
							whiteSpace: 'normal'
						},
						position: {
							top: '130px',
							left: '10%',
							width: '80%',
							height: 'wrap_content'
						}
					}]);
				plus.webview.currentWebview().append(this.content);

			},
			// 创建 开关灯按钮
			createFlashBarView(currentWebview) {
				const openImg = this.crtFlashImg('static/yellow-scanBar.png')
				const closeImg = this.crtFlashImg('static/scanBar.png')
				this.scanBarVew = new plus.nativeObj.View('scanBarVew', {
						top: '65%',
						left: '40%',
						height: '10%',
						width: '20%',
					},
					closeImg);
				this.scanBarVew.interceptTouchEvent(true);

				plus.webview.currentWebview().append(this.scanBarVew);

				this.scanBarVew.addEventListener("click", (e) => { //点亮手电筒
					this.flash = !this.flash;
					if (this.flash) {
						this.scanBarVew.draw(openImg);
					} else {
						this.scanBarVew.draw(closeImg)
					}
					if (this.barcode) {
						this.barcode.setFlash(this.flash);
					}
				}, false)
			},
			crtFlashImg(imgsrc) {
				return [{
					tag: 'img',
					id: 'scanBar',
					src: imgsrc,
					position: {
						width: '28%',
						left: '36%',
						height: '30%'
					}
				}, {
					tag: 'font',
					id: 'font',
					text: '轻触照亮',
					textStyles: {
						size: '10px',
						color: '#ffffff'
					},
					position: {
						width: '80%',
						left: '10%'
					}
				}]
			},

			// 创建返回按钮
			createBackBtn() {
				const closeImg = this.crtBackImg('static/back.png')
				this.scanBackVew = new plus.nativeObj.View('scanBackVew', {
						top: '1.5%',
						left: '0%',
						height: '10%',
						width: '20%',
					},
					closeImg);
				this.scanBackVew.interceptTouchEvent(true);

				plus.webview.currentWebview().append(this.scanBackVew);

				this.scanBackVew.addEventListener("click", (e) => {
					this.close()
				}, false)
			},
			crtBackImg(imgsrc) {
				return [{
					tag: 'img',
					id: 'scanBack',
					src: imgsrc,
					position: {
						width: '28%',
						left: '36%',
						height: '30%'
					}
				}]
			},

			// 创建返回文字按钮
			createBackText() {
				// const openImg = this.crtTextImg('static/yellow-scanBar.png')
				// const closeImg = this.crtTextImg('static/scanBar.png')
				const closeImgText = this.crtTextImg()
				this.scanBarText = new plus.nativeObj.View('scanBarText', {
						top: '75%',
						left: '35%',
						height: '10%',
						width: '30%',

					},
					closeImgText);
				this.scanBarText.interceptTouchEvent(true);

				plus.webview.currentWebview().append(this.scanBarText);

				this.scanBarText.addEventListener("click", (e) => {
					this.close()
				}, false)
			},
			crtTextImg(imgsrc) {
				return [{
					tag: 'font',
					id: 'font',
					text: '点击返回',
					textStyles: {
						size: '16px',
						color: '#ffffff'
					},
					position: {
						width: '80%',
						left: '10%'
					}
				}]
			},
			// 扫码成功回调
			onmarked(type, result) {
				this.close();
				console.log('条码类型：' + type);
				console.log('条码内容：' + result);
				this.$emit('scanCode', result)

			},
			close() {
				plus.webview.currentWebview().remove(this.content)
				plus.webview.currentWebview().remove(this.scanBarVew)
				plus.webview.currentWebview().remove(this.scanBackVew)
				plus.webview.currentWebview().remove(this.scanBarText)
				this.content = null
				this.scanBarVew = null
				this.scanBackVew = null
				this.scanBarText = null
				setTimeout(() => {
					//返回
					this.barcode.close();
					this.barcode = null
				}, 200)


			}

		}
	}
</script>

<style scoped scoped>
	.wrap {
		height: calc(100vh);
		/* #ifdef H5 */
		height: calc(100vh - var(--window-top));
		/* #endif */
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
</style>